import { ingredientService } from "../../services/ingredients.service"

export async function IngredientLoader() {
    return { ingredientIds: await ingredientService.getIds() }
}